import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { makeRequest } from "./../services/api";
import { webEndPoint } from "./../constant/constant";

function GemstoneReady() {
  const { id } = useParams();
  const navigate = useNavigate();

  const handlePreviewClick = async () => {
    const newTab = window.open("", "_blank"); // ✅ open immediately

    try {
      const response = await makeRequest("get", webEndPoint + `download/${id}`);
      const { download_url } = response;

      if (download_url && newTab) {
        newTab.location.href = download_url; // ✅ redirect after API
      } else if (newTab) {
        newTab.close();
      }
    } catch (error) {
      console.error("Download failed", error);
      if (newTab) newTab.close();
    }
  };

  return (
    <div className="gemstone-report-final">
      <div className="final-logo-container">
        <img
          src={`/assets/897c8b986e76400d675cd0f5420f9f811b4a70d2.png`}
          alt=""
          className="glow-bg"
        />
        <img
          src={`/assets/frame-1984078096.png`}
          alt="Gemstone Ready"
          className="check-icon"
        />
      </div>
      <h2 className="report-title">Your Gemstone Report is Ready!</h2>
      <div className="report-msg">
        Your Personalized Gemstone Report is Ready! Tap below to explore your
        recommended Gemstone.{" "}
        <span role="img" aria-label="gem">
          💎
        </span>
      </div>
      <button
        className="generate-btn"
        onClick={handlePreviewClick}
        type="button"
      >
        <img src={`/assets/preview-btn.png`} alt="Generate PDF" />
      </button>
      <button
        className="back-to-home-btn"
        onClick={() => navigate("/gemstone")}
        type="button"
      >
        <img src={`/assets/BackToHome.svg`} alt="back" />
      </button>
    </div>
  );
}

export default GemstoneReady;
